import { useContext } from "react";
import { error400, useIsInstructor } from "../../shared";
import { PortalControllerContext } from "../../context";
import InstructorAssessmentsPage from "./instructor-page";
import StudentAssessmentsPage, { AssessmentTabProvider } from "./student-page";
import homeStyles from "../../portal.module.css";

export default function AssessmentsPage() {
	const { portalContext } = useContext(PortalControllerContext);
	const { instituteId, lmsProvidedCourseId } = portalContext;
	const isInstructor = useIsInstructor();

	if (instituteId == null) {
		return <iframe className={homeStyles.iframePage} src={error400}></iframe>;
	} else if (isInstructor) {
		if (!lmsProvidedCourseId) {
			return <iframe className={homeStyles.iframePage} src={error400}></iframe>;
		} else {
			return <InstructorAssessmentsPage />;
		}
	} else {
		return (
			<AssessmentTabProvider>
				<StudentAssessmentsPage />
			</AssessmentTabProvider>
		);
	}
}
